import { MDBCol, MDBContainer, MDBRow , MDBBtn} from "mdb-react-ui-kit";
import React, { useEffect , useState} from "react";
import Card from "../../component/card";
import Chart from 'chart.js/auto'
import { Colors } from 'chart.js';
const AdminDashboard = () => {
    const auth = localStorage.getItem('auth')
    const [datapeyday, setDataPerDay] = useState([])
    const [male, setmale] = useState("")
    const [female, setFemale] = useState("")
    const [totaluser, setTotalUser] = useState([])
    const [date, setDate] = useState([])
    const [chart, setChart] = useState(null);

   
    useEffect(() => {
        if (!auth) {
            localStorage.clear();
            window.location.href = '/';
        }

        fetch(`${process.env.REACT_APP_URL}usercount/find`)
            .then(result => result.json())
            .then(data => {
                const male = data.data.filter(e => e.gender === 'male');
                const females = data.data.filter(e => e.gender === 'female');
                setDataPerDay(data.data);
                setmale(male);
                setFemale(females);
               
            });
            
    }, []);

    useEffect(()=>{
         // ... Your data processing logic ...
         const thisYear = datapeyday.filter(
            data =>
              new Date().getFullYear() === new Date(data.createdAt).getFullYear()
          );
    
          const thisMonth = thisYear.filter(
            data => new Date().getMonth() === new Date(data.createdAt).getMonth()
          );
    
          // Get the available labels for this task
          const dates = Array.from(
            new Set(thisMonth.map(data => new Date(data.createdAt).toDateString()))
          );
            setDate(dates)
          const users = dates.map(data =>
            thisMonth.filter(
              user => new Date(user.createdAt).toDateString() === data
            )
          );
          setTotalUser(users.map(row => row.length))
    },[datapeyday])

    useEffect(()=>{
         // Create the new chart instance
         const data = [
            {
                label : 'Total User', count: datapeyday.length,  color: '#4BC0C0'
            },
            {
                label : 'Male', count: male.length, color: '#36A2EB'
            },
            {
                label : 'Female', count: female.length, color: '#FF6384'
            }
         ]
         const canvas = document.getElementById('dataperday');
         if (canvas) {
             const existingChart = Chart.getChart(canvas);
             if (existingChart) {
                 existingChart.destroy();
             }
             const newChart = new Chart(canvas, {
                 type: 'bar',
                 data: {
                     labels: data.map(l=> l.label),
                     datasets: [
                         {
                             label: 'Users Per Day',
                             data: data.map(t => t.count),
                             backgroundColor: data.map(c => c.color)
                         },
                     ],
                 },
             });
             setChart(newChart);
         }
         
    },[date,totaluser])
    const handlePrint = () => {
        window.print();
      };
    return(
        <MDBContainer>
            <MDBRow>
                <MDBCol className="mt-5">
                    <MDBBtn onClick={handlePrint}>
                        PRINT
                    </MDBBtn>
                </MDBCol>
            </MDBRow>
            <MDBContainer id="section-to-print">
            <MDBRow>
                <MDBCol>
                <Card 
                cardtitle={`Total Users`}
                cardtext={datapeyday.length}
                />
                </MDBCol>
                <MDBCol>
                <Card
                cardtitle={`Total Male Users`}
                cardtext={male.length}
                />
                </MDBCol>
                <MDBCol>
                <Card
                cardtitle={`Total Female Users`}
                cardtext={female.length}
                />
                </MDBCol>
            </MDBRow>
            <MDBRow>
                <MDBCol>
                    <canvas className="mt-5" id="dataperday">

                    </canvas>
                </MDBCol>
            </MDBRow>
            </MDBContainer>
            
        </MDBContainer>
    )
}

export default AdminDashboard;